export default () => {
  const scriptTagId = 'recaptcha-component'

  if (document.getElementById(scriptTagId) !== null) return

  const scriptTag = document.createElement('script')
  scriptTag.setAttribute('id', scriptTagId)
  scriptTag.setAttribute(
    'src',
    `https://www.google.com/recaptcha/api.js?render=${
      import.meta.env.VITE_RECAPTCHA_SITE_KEY
    }`
  )
  document.body.appendChild(scriptTag)
}
